module.exports = __webpack_public_path__ + "img/1.9a3914d6.png";